import React, { useEffect, useRef, useState } from "react";

const STATS = [
  { value: 100, suffix: "", label: "Stations", sub: "Vision 2030" },
  { value: 250, suffix: "+", label: "Ans d'expertise", sub: "Héritage Wayne" },
  { value: 100, suffix: "%", label: "Couverture nationale", sub: "Objectif réseau" },
  { value: 1, suffix: "", label: "Écosystème intégré", sub: "Groupe EKIP" },
];

function Counter({ target, suffix }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const dur = 1800;
            const start = performance.now();
            const tick = (t) => {
              const p = Math.min(1, (t - start) / dur);
              const eased = 1 - Math.pow(1 - p, 3);
              setVal(Math.round(target * eased));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, [target]);

  return (
    <span ref={ref} className="font-display font-black text-[#E85D26]">
      {val}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="bg-[#1A2744] py-16 sm:py-20 relative"
    >
      <div className="kip-container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 lg:gap-0">
          {STATS.map((s, idx) => (
            <div
              key={s.label}
              data-testid={`stat-${idx}`}
              className={`px-6 lg:px-8 text-left ${
                idx < STATS.length - 1 ? "lg:border-r lg:border-[#E85D26]/25" : ""
              }`}
            >
              <div className="text-5xl sm:text-6xl lg:text-7xl leading-none tracking-tight">
                <Counter target={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-3 text-white font-semibold text-lg tracking-tight">
                {s.label}
              </div>
              <div className="text-white/50 text-sm mt-1 tracking-wide">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
